export default __webpack_public_path__ + "static/media/080_finish_soso.c370edf5.mp4";